import { render, staticRenderFns } from "./NeedContent.vue?vue&type=template&id=1e7d6166&"
import script from "./NeedContent.vue?vue&type=script&lang=js&"
export * from "./NeedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedContent.vue"
export default component.exports